import React from 'react';
import { CheckCircle2Icon, ShieldCheckIcon } from 'lucide-react';
import { CountdownUrgency } from './CountdownUrgency';
import { BuyButton } from './BuyButton';
import { CHECKOUT_URL } from '../data/content';
const ORDER_ITEMS = [{
  label: '7 Complete Modules (PDF)',
  value: 'Included'
}, {
  label: 'Bonus 1 · Class Generator (Excel)',
  value: 'FREE'
}, {
  label: 'Bonus 2 · Pricing Calculator (Excel)',
  value: 'FREE'
}, {
  label: 'Bonus 3 · Student CRM (Excel)',
  value: 'FREE'
}, {
  label: 'Bonus 4 · Legal Kit (Word)',
  value: 'FREE'
}, {
  label: 'Bonus 5 · Message Kit (Word)',
  value: 'FREE'
}, {
  label: 'Bonus 6 · Pre-Built Class Library (Word)',
  value: 'FREE'
}];
function goToCheckout() {
  window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
}
export function FinalOffer() {
  return <section id="oferta" className="scroll-mt-4 px-5 py-10" data-id="element-77">
      <div className="mx-auto max-w-md" data-id="element-78">
        <div className="overflow-hidden rounded-3xl border border-[var(--pb-lime)]/45 bg-[#101b2d]/98 shadow-2xl shadow-black/60" data-id="element-79">
          <div className="bg-[var(--pb-lime)] px-5 py-3 text-center" data-id="element-80">
            <p className="font-display text-lg font-800 uppercase tracking-wide text-[var(--pb-navy)]" data-id="element-81">
              🏓 Pickleball Coach 360 Kit
            </p>
          </div>

          <div className="p-5" data-id="element-82">
            <CountdownUrgency data-id="element-83" />

            {/* Order summary */}
            <div className="mt-5" data-id="element-84">
              <p className="mb-3 text-xs font-700 uppercase tracking-widest text-white/70" data-id="element-85">
                Order Summary
              </p>
              <ul className="space-y-2" data-id="element-86">
                {ORDER_ITEMS.map(item => <li key={item.label} className="flex items-center justify-between gap-2 text-sm" data-id="element-87">
                    <span className="flex items-start gap-2 text-white/80" data-id="element-88">
                      <CheckCircle2Icon size={15} className="mt-0.5 shrink-0 text-[var(--pb-lime)]" data-id="element-89" />
                      {item.label}
                    </span>
                    <span className={`shrink-0 text-xs font-700 ${item.value === 'FREE' ? 'text-[var(--pb-lime)]' : 'text-white/70'}`} data-id="element-90">
                      {item.value}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* Price */}
            <div className="mt-6 flex items-end justify-center gap-3" data-id="element-91">
              <span className="text-2xl font-600 text-white/40 line-through" data-id="element-92">
                $75 USD
              </span>
              <span className="font-display text-6xl font-800 leading-none text-[var(--pb-lime)]" data-id="element-93">
                $25
              </span>
              <span className="mb-1 text-lg font-700 text-white" data-id="element-94">USD</span>
            </div>
            <p className="mt-1 text-center text-xs text-white/70" data-id="element-95">
              One-time payment · Instant access · No subscriptions
            </p>

            <div className="mt-5" data-id="element-96">
              <BuyButton onClick={goToCheckout} data-id="element-97" />
            </div>

            <div className="mt-4 flex items-center justify-center gap-2 text-xs text-white/80" data-id="element-98">
              <ShieldCheckIcon size={14} className="text-[var(--pb-lime)]" data-id="element-99" />
              100% secure checkout · Automatic email delivery
            </div>
          </div>
        </div>
      </div>
    </section>;
}